// Mockups visuais do sistema (CSS puro, decorativos) reusados na home e no guia.

const ico = (d: string) => (
  <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
    <path d={d} />
  </svg>
);

// Ícones dos 6 recursos (ordem espelha marketing.features)
export const FEATURE_ICONS = [
  ico('M12 7v5l3 2 M12 21a9 9 0 1 1 0-18 9 9 0 0 1 0 18Z'), // fila (relógio)
  ico('M7 3h10v18l-2.5-1.5L12 21l-2.5-1.5L7 21V3Z M9 8h6 M9 12h6'), // comanda (recibo)
  ico('M4 4h6v6H4V4Z M14 4h6v6h-6V4Z M4 14h6v6H4v-6Z M14 14h3v3h-3v-3Z'), // cardápio (QR)
  ico('M5 9h14l-1 11H6L5 9Z M9 9V6a3 3 0 0 1 6 0v3'), // cozinha (panela)
  ico('M12 3l2.5 5.5L20 9l-4 4 1 6-5-3-5 3 1-6-4-4 5.5-.5L12 3Z'), // fidelidade (estrela)
  ico('M12 3v4 M12 17v4 M3 12h4 M17 12h4 M6 6l2 2 M16 16l2 2 M18 6l-2 2 M8 16l-2 2') // IA (brilho)
];

export function PhoneMenu() {
  return (
    <div className="device" aria-hidden="true">
      <div className="device__screen">
        <div className="pm-head"><span className="pm-logo" />La petite table</div>
        <div className="pm-cat">Pratos</div>
        <div className="pm-item"><span>Risoto de cogumelos</span><b>R$59</b></div>
        <div className="pm-item"><span>Steak ao molho</span><b>R$79</b></div>
        <div className="pm-cat">Bebidas</div>
        <div className="pm-item"><span>Cerveja artesanal</span><b>R$22</b></div>
        <div className="pm-item"><span>Suco natural</span><b>R$14</b></div>
        <div className="pm-cart">Enviar pedido · 2 itens</div>
      </div>
    </div>
  );
}

export function KdsBoard() {
  return (
    <div className="kds-mini" aria-hidden="true">
      {[
        { t: 'Na fila', c: '2× Risoto', m: 'Mesa 14' },
        { t: 'Em preparo', c: '1× Steak', m: 'Mesa 03' },
        { t: 'Pronto', c: '1× Bruschetta', m: 'Mesa 07' }
      ].map((col, i) => (
        <div className="kmcol" key={i}>
          <span className="kmcol__t">{col.t}</span>
          <div className="kmcard"><b>{col.m}</b>{col.c}</div>
        </div>
      ))}
    </div>
  );
}

export function LoyaltyCard() {
  return (
    <div className="loy-card" aria-hidden="true">
      <div className="loy-card__top"><span>★</span> 8 / 10</div>
      <div className="loy-bar"><i style={{ width: '80%' }} /></div>
      <span className="loy-card__reward">🎁 Sobremesa grátis</span>
    </div>
  );
}

export function QueueCard() {
  return (
    <div className="queue-mini" aria-hidden="true">
      {[
        { p: '1', n: 'Ana', g: '2', tag: 'Mesa pronta', ready: true },
        { p: '2', n: 'Bruno', g: '4', tag: '~10 min', ready: false },
        { p: '3', n: 'Carla', g: '2', tag: '~15 min', ready: false }
      ].map((r) => (
        <div className="qm-row" key={r.p}>
          <span className="qm-pos">{r.p}</span>
          <b className="qm-name">{r.n}</b>
          <span className="qm-people">{r.g} pessoas</span>
          <span className={`qm-tag${r.ready ? ' is-ready' : ''}`}>{r.tag}</span>
        </div>
      ))}
    </div>
  );
}

export function TablesGrid() {
  return (
    <div className="tbl-mini" aria-hidden="true">
      {[
        { n: '01', s: 'ocupada', v: 'R$120' },
        { n: '02', s: 'livre', v: '—' },
        { n: '03', s: 'conta', v: 'R$248' },
        { n: '04', s: 'ocupada', v: 'R$76' },
        { n: '05', s: 'livre', v: '—' },
        { n: '06', s: 'ocupada', v: 'R$192' }
      ].map((t) => (
        <div className={`tbl-card is-${t.s}`} key={t.n}>
          <span className="tbl-card__n">Mesa {t.n}</span>
          <span className="tbl-card__v">{t.v}</span>
        </div>
      ))}
    </div>
  );
}
